import styled, { css } from 'styled-components';

import { Typography } from '@/components/ui/Typography/Typography.styles';
import { CONTAINER_MAX } from '@/constants/breakpoints';
import { Z_INDEX } from '@/constants/z-index';
import { flexBetween, flexColumn } from '@/styles/common';

export const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  width: 100vw;
  height: 100svh;
  ${flexColumn}
`;

export const HeaderWrapper = styled.div<{
  $isBack?: boolean;
  $isCenter?: boolean;
  $bottomSheet?: boolean;
}>`
  ${flexBetween};
  position: relative;
  padding-top: 25px;
  ${({ $isCenter }) =>
    $isCenter &&
    css`
      justify-content: center;
    `}
  padding-left: ${({ $isBack, $isCenter }) =>
    $isBack ? '45px' : $isCenter ? '0px' : '20px'};
  padding-right: ${({ $isCenter }) => ($isCenter ? '0px' : '60px')};
  padding-bottom: 20px;

  @media (max-width: ${CONTAINER_MAX.mobileL}) {
    padding-bottom: 16px;
  }

  @media (max-width: ${CONTAINER_MAX.tablet}) {
    &:after {
      position: absolute;
      top: 5px;
      left: 50%;
      width: 65px;
      height: 4px;
      content: ' ';
      transform: translateX(-50%);
      background-color: var(--border-secondary);
    }
  }

  ${({ $bottomSheet }) =>
    $bottomSheet &&
    css`
      @media (max-width: ${CONTAINER_MAX.mobileL}) {
        min-height: 62px;
        padding-top: 0;
        padding-bottom: 0;

        &:after {
          display: none;
        }
      }
    `}
`;

export const ContentWrapper = styled.div<{
  $bottomSheet?: boolean;
  $centerContent?: boolean;
}>`
  overflow-y: auto;
  background-color: inherit;
  will-change: height;

  ${({ $bottomSheet }) =>
    $bottomSheet &&
    css`
      background: var(--bg-main);
      border-radius: 28px 28px 0 0;
      padding: 24px 16px;
    `}

  ${({ $centerContent }) =>
    $centerContent &&
    css`
      @media (max-width: ${CONTAINER_MAX.tablet}) {
        & > div > * {
          margin-inline: auto;
        }
      }
    `}
`;

export const FooterWrapper = styled.div`
  z-index: ${Z_INDEX.MODAL};
  bottom: 0;
  width: 100%;

  display: flex;
  gap: 20px;
  padding: 22px 40px;
  position: fixed;
  background-color: var(--bg-main);
  left: 0;

  @media (max-width: ${CONTAINER_MAX.mobileL}) {
    padding-inline: 16px;
  }
`;

export const CrossButton = styled.button.attrs({ type: 'button' })`
  display: flex;
  background: none;
  border: none;
  border-radius: 50%;
  color: var(--textAndLabels-tertiary);
  cursor: pointer;
  transition: all 0.3s ease;
  margin-right: 20px;
  position: absolute;
  right: 0;

  &:hover {
    color: var(--system-yellow);
  }

  & svg {
    width: 16px;
    height: 16px;
  }
`;

export const BackButton = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  border-radius: 50%;
  color: var(--textAndLabels-tertiary);
  cursor: pointer;
  transition: all 0.3s ease;
  margin-left: 20px;
  position: absolute;
  left: 0;
`;

export const DrawerTitle = styled(Typography).attrs({ variant: 'h4' })`
  color: var(--textAndLabels-main);
`;
